import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as CloseBtn } from '../../../assets/images/graphics/btn-close.svg';
import { useWindowSize } from '../../../models/Hooks';
import { calculateSize, getNavbarHeight, getImageFilepath } from '../../../models/Utils';
import { setMediaState, setInFullScreenVideo } from '../../../store/reducers/mainReducer';
import { reportEvent } from '../../../store/reducers/gaReducer';

import ReactPlayer from 'react-player';

import './VideoIntro.scss';
import Spinner from '../../Common/Spinner/Spinner';
import { ADAARIARoles, ADAWidgitRoles } from '../../../models/ADA';


const VideoIntro = ({ data, active }) => {
  const dispatch = useDispatch();
  const size = useWindowSize();
  const player = useRef(null);
  const isInitialized = useSelector(state => state.data.initialized);
  const videoTimeout = useSelector(state => state.data.videoFadeTimeout);
  const cmsData = useSelector(state => state.data.cms.poweredByPurpose);
  const mediaPath = useSelector(state => state.config.basePath + state.config.apiMediaPath);

  const [topOffset, setTopOffset] = useState(0);
  const [playing, setPlaying] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const [muted, setMuted] = useState(true);
  const [fullscreen, goToFullscreen] = useState(false);
  const menuOpened = useSelector(state => state.data.menuOpened);

  useEffect(() => {
    setTopOffset(getNavbarHeight());
  }, [size]);

  useEffect(() => {

    clearTimeout(fadeTimeout);

    if (active) {
      reset();
      delayedFade()
    } else {
      setMuted(true);
      goToFullscreen(false);
      dispatch(setInFullScreenVideo(false));
      setPlaying(false);
    }
  }, [active]);

  const reset = prop => {
    setPlaying(true);
    setMuted(true);
    goToFullscreen(false);
    dispatch(setInFullScreenVideo(false));
    if (loaded && player && player.current) {
      player.current.seekTo(0, 'fraction');
    }
  };

  useEffect(() => {
    dispatch(setMediaState(fullscreen));
  }, [fullscreen]);

  const handleMaximizeClicked = () => {
    setPlaying(true);
    setMuted(false);
    setLoaded(false);
    goToFullscreen(true);
    delayedFade();
    dispatch(setInFullScreenVideo(true));
    dispatch(reportEvent({ category:"VIDEO_PLAYED_PBP_INTRO", action: cmsData.Introduction.Header + " - " + data.Video.URL}));
  };

  if (!isInitialized || !cmsData) {
    return null;
  }

  var text = (
    <div className="text-holder">
      <h1 role={ADAARIARoles.Heading} className="header">{cmsData.Introduction.Header}</h1>
      <div className="body">{cmsData.Introduction.Body}</div>
      <button  tabIndex="0" role={ADAWidgitRoles.Button} aria-label="Video Play"  onClick={handleMaximizeClicked} className="video-play-button" >
        <img className='video-play-button-img' />
      </button>
    </div>
  );

    var fadeTimeout;
  function delayedFade() {
    fadeTimeout = setTimeout(handleVideoStart, videoTimeout);
  }

  function handleVideoStart() {
    setLoaded(true);
  }

  const handleOnExit = () => {
    goToFullscreen(false);
    dispatch(setInFullScreenVideo(false));
    setMuted(true);
  };

  var width = size.width;
  var height = size.height - topOffset;
  var dimensions = calculateSize(1920, 1080, width, height);

  var video = (
    <ReactPlayer
      ref={player}
      className="video"
      url={fullscreen ? data.Video.URL : data.VideoPreview.BackgroundMedia ? mediaPath + data.VideoPreview.BackgroundMedia : data.VideoPreview.URL}
      width={fullscreen ? width + 'px' : dimensions.width + 'px'}
      height={fullscreen ? height + 'px' : dimensions.height + 'px'}
      playing={playing}
      playsinline={fullscreen === false}
      controls={fullscreen}
      loop={fullscreen === false}
      onStart={handleVideoStart}
      muted={muted}
      config={{
        youtube: {
          playerVars: {
            showinfo: 1,
            modestbranding: 1,
          },
        },
      }}
    />
  );

  var imagePlaceholder = data.Video.BackgroundMedia ? (
    <img src={mediaPath + getImageFilepath(data.Video.BackgroundMedia)}
      className="background-image" />
  ) : null;

  

  var classname = 'videofadein ' + (loaded ? 'loaded' : '');
  //var classnameFullScreen = "video-fullscreen " + (loaded ? 'loaded' : '');


  return (
    <div className="pbp-video-intro" style={{ top: topOffset+"px", height: "calc(100% - "+topOffset+"px)" }}>
      {fullscreen ? (
        <div className="fullscreenContainer" style={{pointerEvents: loaded ? "all" :"none"}}>
           <Spinner/>
           <div className={classname}>
            {data.VideoPreview.BackgroundMedia ?
              data.VideoPreview.BackgroundMedia.split(".").pop() === "mp4" ?
                video : imagePlaceholder
              : video}
      
          <CloseBtn className="exit-button" tabIndex="0" role="button" aria-label="close" onKeyDown={handleOnExit} onClick={handleOnExit} />
   
        </div>
       </div>
        
      ) : (
        <>
          <div className="video-placeholder">
              <div className={classname} role="img" alt={data.Video.AltText}>
                {data.VideoPreview.BackgroundMedia? data.VideoPreview.BackgroundMedia.split(".").pop() === "mp4" ? video : imagePlaceholder : video}

              </div>
            </div>
            {text}
          <button tabIndex={-1} aria-label={"Video Play"} className="video-touch-blocker"  onClick={handleMaximizeClicked} onKeyPress={handleMaximizeClicked}  style={{opacity:0, pointerEvents: loaded ? "all" :"none"}}/>
          
        </>
      )}

    </div>
  );
};

export default VideoIntro;
